<div fxLayout="column" style="height: 100%;" *ngIf="!filterType">

    <div fxLayout="row" fxLayoutAlign="space-between center" class="header-row" fxFlex="10">
        <div fxFlex="auto" class="header-text">
            Filters
        </div>
        <div fxFlex="none">
            <mat-icon [attr.guide]="'column-visibility-btn-0-1' + '__' + sanitizeUrl(url)" (click)="callclosepopup()"
                style="cursor:pointer;">close</mat-icon>
        </div>
    </div>
    <div fxFlex="5">

    </div>
    <div fxFlex class="formfield">
        <button [attr.guide]="'column-visibility-btn-1-1' + '__' + sanitizeUrl(url)" class="checkbox-item mat-menu-item"
            *ngFor="let column of columns; let i = index" (click)="toggleColumnVisibility(column, $event)"
            [disabled]="column.disabled">
            <mat-checkbox [attr.guide]="'column-visibility-chk-2-1' + '__' + sanitizeUrl(url)"
                [(ngModel)]="column.visible" class="checkbox" #checkbox (click)="$event.stopPropagation()"
                [disabled]="column.disabled">
                {{ column.name | uppercase }}
            </mat-checkbox>
        </button>
    </div>

    <div fxFlex="5">

    </div>


    <div fxFlex="none" class="footer-container">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="footer-row">

            <div fxFlex="100">
                <button [attr.guide]="'column-visibility-btn-3-1' + '__' + sanitizeUrl(url)" matTooltip="Apply"
                    mat-raised-button (click)="callclosepopup()">
                    Apply & Close
                </button>
            </div>

            <div fxFlex="100">
                <button [attr.guide]="'column-visibility-btn-4-1' + '__' + sanitizeUrl(url)" mat-raised-button
                    color="accent" (click)="callclosepopup()" style="width: auto;" class="closebutton">Close</button>
            </div>
        </div>
    </div>

</div>
<div *ngIf="filterType">
    <div fxFlex class="formfield">
        <button [attr.guide]="'column-visibility-btn-5-1' + '__' + sanitizeUrl(url)" class="checkbox-item mat-menu-item"
            *ngFor="let column of columnsVisble; let i = index" (click)="toggleColumnVisibility(column, $event)"
            [disabled]="column.disabled">
            <mat-checkbox [attr.guide]="'column-visibility-chk-6-1' + '__' + sanitizeUrl(url)"
                [(ngModel)]="column.visible" class="checkbox" #checkbox (click)="$event.stopPropagation()"
                [disabled]="column.disabled">
                {{ column.name | uppercase }}
            </mat-checkbox>
        </button>
    </div>

</div>